import React from 'react';
import PropTypes from 'prop-types'
import AppStore from '../../stores/AppStore';
import * as AppActions from '../../actions/AppActions';
import TemplateData, { localsMessages, guestLocalsMessages } from '../../utility/getTemplateData';
import CharityLogo from '../../components/CharityLogo';
import SubHeader from '../../components/subHeader';
import SingleAmount from '../../components/amount/SingleAmount';
import CancelAndReturn from '../../components/cancelAndReturn';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import DonateGiftAid from '../../guest-payment-components/DonateGiftAid';
import * as FPT from '../../utility/fpt'
import CurrencyConversionModal from '../../components/currencyConversion/CurrencyConversionModal';
import { normalizeNumber } from '../../utility/formator';
import { withRouter } from "react-router-dom";
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import { setCountryAndLocale, parseErrorResponse } from '../../utility/helper';
import { hideLanguageSelector } from '../../utility/languageSelector';
import CVVComponent from '../../containers/cvv-component';
import withDonate from '../../components/guest/WithDonate';
import ThreeDSContainer from '../../components/threeDS/ThreeDSContainer';
import $ from 'jquery';
import { Alert, Text, Button } from '@paypalcorp/pp-react'

let giftAidText = localsMessages('common/giftAidIt');
const donateGiftPercentage = AppStore.getGiftAidItExtraAmount();
let giftAidTextObj = giftAidText && giftAidText.giftAidIt || {};
let { extraCost } = giftAidTextObj;
const guestMessages = guestLocalsMessages('guest/guestForm');
const messages = localsMessages('guest/crossBorder');
const errorMessages = localsMessages('errors/service')

const STYLES = StyleSheet.create({
	donateBtnContainer: {
		maxWidth: '360px',
		margin: '20px auto 0px',
	},
	donateBtn: {
		marginBottom: 0,
	},
	centralFormWrapper: {
		maxWidth: '500px',
		width: '100%',
		margin: '0 auto',
		padding: '0 18px',
	},
	donationSeparator: {
		marginBottom: '25px'
	},
	formTopLabelBold: {
		fontWeight: 'bold',
		marginTop: 31,
		fontSize: 15,
	},
	formLabelLeft: {
		width: '70%',
		fontSize: 15,
		textAlign: 'left',
	},
	formLabelRight: {
		width: '30%',
		fontSize: 15,
		textAlign: 'right',
	},
	formLabelLeftConv: {
		width: '70%',
		fontSize: 12,
		textAlign: 'left',
	},
	formLabelRightConv: {
		width: '30%',
		fontSize: 12,
		textAlign: 'right',
	},
	formLabelCenter: {
		width: '100%',
		marginTop: '10px',
		textAlign: 'center'
	},
	
	formLabelRateLeft: {
		width: '70%',
		fontSize: 12,
		textAlign: 'left',
	},
	formLabelRateRight: {
		width: '30%',
		fontSize: 12,
		textAlign: 'right',
	},
	conversionRate: {
		maxWidth: '500px',
		width: '100%',
		padding: '0 18px',
		margin: '12px auto 0'
	},
	policyMsg: {
		fontSize: '0.85em',
		textAlign: 'center',
		color: '#848B8E'
	},
	labelFont: {
		fontSize: 12,
	},
	link: {
		color: '#0270ba'
	},
	currencyConversionOptionsLink: {
		paddingLeft: '12px'
	}
});

const DYNAMIC_CURRENCY_CONVERSION_TAG = 'DYNAMIC_CURRENCY_CONVERSION';
export const CURRENCY_CONVERSION_OPTIONS = {
	PAYPAL: 'PAYPAL',
	ISSUER: 'ISSUER'
};

class CrossBorder extends React.Component {
	constructor(props) {
		super(props);

		let isRecurring = !!AppStore.getDonationRecurring();
		const stateConversionWithPayPal = this.getStateForConversionWithPayPal();

		this.state = {
			subHeaderLabel: TemplateData.donationName,
			donationId: AppStore.getSelectedProgram() || TemplateData.donationId,
			orgName: TemplateData.charityName,
			amountDecimalPoint: TemplateData.donationDecimalPoint || '.',
			decimalPoint: TemplateData.donationDecimalPoint || '.',
			isRecurring,
			...stateConversionWithPayPal,
			showCVVField: false,
			securityCode: '',
			isCurrencyConversionModalOpen: false
		};
	};

	componentDidMount() {
		hideLanguageSelector();
	}

	getStateForConversionWithPayPal() {
		let fundingOptions = AppStore.getFundingOptions();
		let [fundingSources] = fundingOptions ? fundingOptions.sources : [];
		let paymentNetwork = fundingSources.payment_card.network.toLowerCase();
		paymentNetwork = paymentNetwork.charAt(0).toUpperCase() + paymentNetwork.slice(1);
		let paymentDigits = fundingSources.payment_card.last_4;
		let exchangeRate = parseFloat(
			fundingOptions.currency_conversion.exchange_rate
		).toFixed(2);
		let fundsIn = fundingOptions.currency_conversion.funds_in;
		let fundsOut = fundingOptions.currency_conversion.funds_out;
		let isRecurring = !!AppStore.getDonationRecurring();

		return {
			exchangeRate,
			paymentCard: `${paymentNetwork} x-${paymentDigits}`,
			inAmount: fundsIn.value,
			inCurrency: fundsIn.currency,
			inSymbol: fundsIn.symbol,
			outAmount: fundsOut.value,
			outCurrency: fundsOut.currency,
			outSymbol: fundsOut.symbol,
			currencyConversionOption: CURRENCY_CONVERSION_OPTIONS.PAYPAL
		}
	};

	getStateForConversionWithIssuer() {
		let amount = AppStore.getDonationAmount();
		let symbol = AppStore.getDonationSymbol();
		let currency = AppStore.getDonationCode();

		// No currency_conversion. fundsIn and fundsOut will not be available.
		return {
			amount,
			symbol,
			currency,
			currencyConversionOption: CURRENCY_CONVERSION_OPTIONS.ISSUER
		};
	};

	updateFundingOptionsState() {
		let fundingOptions = AppStore.getFundingOptions();
		if (!fundingOptions.currency_conversion) {
			this.setState(this.getStateForConversionWithIssuer());
		} else {
			this.setState(this.getStateForConversionWithPayPal());
		}
	};

    getLocalizedAmount = (amount) => {
		amount = (parseFloat(amount)).toFixed(2);
		return `${amount}`.replace(/[.|,]/i, this.state.amountDecimalPoint);
	};

	handleCurrencyConversionClick = () => {
		FPT.trackLinkClick('showCurrencyConversionModal');
		this.showCurrencyConversionModal();
	};

	showCurrencyConversionModal = () => {
		this.setState({
			isCurrencyConversionModalOpen: true
		})
	};

	hideCurrencyConversionModal = () => {
		this.setState({
			isCurrencyConversionModalOpen: false
		})
	};

    handleDonateClick = () => {
		if (this.state.showCVVField) {
			const cvv = document.getElementById('securityCode').value;
			this.childCVVInfo.handleFieldBlur(cvv, 'errorMessageCSC', 'REQUIRED_SECURITY_CODE', 'INVALID_SECURITY_CODE');

			let hasError = document.getElementsByClassName('vx_has-error-with-message').length > 0;
			if (!cvv || hasError) {
				return;
			}
		}
		const fundingOptions = AppStore.getFundingOptions();
		const contingencies = _get(fundingOptions, 'contingencies') || [];
		const threeDSContingency = _find(contingencies, { action: '3D_SECURE_DATA_COLLECTION_REQUIRED' }) || {};

		if (!_isEmpty(threeDSContingency)) {
			this.threeDSContainer.initializeThreeDS();
			
			FPT.addFi(fundingOptions, 'main:donate:wps:guest:crossborder', 'main:donate:wps:guest:crossborder:web::');

			return;
		}

		// All contingencies resolved
		this.processDonation();
	};

	processDonation = () => {
		$('.spinneroverlay').show();

		return this.props.doFulfilment({
			securityCode: this.state.securityCode
		});
	}

	handleGiftAidOption = (giftAidState) =>  {
		AppActions.updateGiftaidItFlag({ giftAidItFlag: giftAidState });
	};

	updateGiftAidComponent = (state) => {
		let extraCostText = extraCost;
		extraCostText = extraCostText && extraCostText.replace(/{currency}/g, state.outSymbol);
		extraCostText = extraCostText && extraCostText.replace("{amount}", state.outAmount);
		extraCostText = extraCostText && extraCostText.replace("{extraAmount}", (donateGiftPercentage * state.outAmount).toFixed(2));

		let modalp1 = giftAidTextObj && giftAidTextObj.modalp1 || '',
		modalp2 = giftAidTextObj && giftAidTextObj.modalp2 || '',
		applyGiftAid = giftAidTextObj && giftAidTextObj.applyGiftAid || '';

		modalp1 = modalp1 && modalp1.replace("{orgName}", state.subHeaderLabel);
		modalp2 = modalp2 && modalp2.replace("{orgName}", state.subHeaderLabel);
		applyGiftAid = applyGiftAid && applyGiftAid.replace("{orgName}", state.subHeaderLabel);

		giftAidTextObj.extraCost = extraCostText;
		giftAidTextObj.modalp1 = modalp1;
		giftAidTextObj.modalp2 = modalp2;
		giftAidTextObj.applyGiftAid = applyGiftAid;
	}

	handleOptionSelection = (option) => {
		const beforeOption = this.state.currencyConversionOption;
		this.setState({
			currencyConversionOption: option
		}, () => {
			// Do Planning if the option has changed
			if (beforeOption !== option) {
				this.hideCurrencyConversionModal();
				this.showSpinnerOverlay();
				this.getFundingOptions()
					.always(() => {
						this.hideSpinnerOverlay();
					});
			} else {
				setTimeout(() => {
					this.hideCurrencyConversionModal();
				}, 300);
			}
		});
	};

	showSpinnerOverlay() {
		$('.spinneroverlay').show();
	};
	hideSpinnerOverlay() {
		$('.spinneroverlay').hide();
	};

	showCVVComponent() {
		this.setState({
			showCVVField: true
		})
	}

	hideCVVComponent() {
		this.setState({
			showCVVField: false
		})
	}

	getFundingOptions() {
		const lastFundingSource = this.getLastFundingSource();
		const paymentCardId = _get(lastFundingSource, 'payment_card.id');

		const currencyConversionType = this.state.currencyConversionOption;

		return $.post('/donate/guest/fundingOptions', {
			amount: normalizeNumber(AppStore.getDonationAmount()),
			code: AppStore.getDonationCode(),
			fundingOptionId: AppStore.getFundingOptions().id,
			preferences: {
				currency_conversion: [{
					"payment_card_id": paymentCardId,
					"type": currencyConversionType,
					"validity": "TRANSACTION"
				}]
			},
			consentShareAddress: AppStore.getShareAddress()
		}, (result) => {
			console.log('getFundingOptions result :: ', result);

			let fundingOptions;
			// The funding options data format returned by the server is
			// different for ISSUER and PAYPAL. Handle it appropriately.

			// For conversion with 'ISSUER'
			if (currencyConversionType === CURRENCY_CONVERSION_OPTIONS.ISSUER) {
				fundingOptions = _get(result, 'data.fundingOpt[0]');
			} else {
				// For conversion with 'PAYPAL'
				fundingOptions = _get(result, 'fundingOpts[0]');
			}

			// Handle error case where fundingOptions call succeeds
			// but no data is returned
			if (_isEmpty(fundingOptions)) {
				FPT.trackError({
					message: 'FUNDING_OPTIONS_EMPTY_CROSSBORDER',
					code: currencyConversionType
				});
				this.props.history.push('/donate/error/payment');
				return;
			}

			// If CVV contingencies are present and has not been resolved,
			// then display cvv component
			const contingencies = _get(fundingOptions, 'contingencies');
			const hasCvvContingency = _find(contingencies, { action: 'CVV_REQUIRED' });
			const isCvvContingencyResolved = _get(result, 'data.contingencyResolutionStatus.cvvContingencyResolved', false);

			if (hasCvvContingency && !isCvvContingencyResolved) {
				this.showCVVComponent();
			} else {
				this.hideCVVComponent();
			}

			// Updating store with funding options
			AppActions.updateFundingOptions({ fundingOptions });

			this.updateFundingOptionsState();

			console.log(result);
		}).fail(() => {
			console.log('FAILED');
			this.props.history.push('/donate/error/payment');
		}).always(() => {
			$('.spinneroverlay').hide();
		});
	};

	renderConversionRateInfo(exchangeRate, fundsOut) {
		const label = _get(messages, 'label', {});
		return (
			<div className="ppvx_row">
            	<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
            		<div>
						<Text as="span" size="sm">{label.conversion} {exchangeRate}</Text>
            		</div>
            		<div>
            			<Text as="span" size="sm">{fundsOut}</Text>
            		</div>
            	</div>
        	</div>
		)
	};

	getLastFundingSource() {
		let fundingOptions = AppStore.getFundingOptions();
		const fundingSources = fundingOptions.sources || [];
		return fundingSources[fundingSources.length - 1];
	};

	/**
	 * Returns true if currency conversion options should be displayed
	 * @param  {Array} fundingSources Funding Sources
	 * @return {Boolean}              True if currency conversion options should be displayed
	 */
	shouldShowCurrencyConversionOptions = () => {
		const lastFundingSource = this.getLastFundingSource();
		const tags = _get(lastFundingSource, 'tags');
		return _includes(tags, DYNAMIC_CURRENCY_CONVERSION_TAG);
	};

	renderCurrencyConversionOptionsLink(label) {
		const userCountry = AppStore.getUserCountry();

		return (
			<React.Fragment>
				<div className="ppvx_row">
					<div className="ppvx_col-12">
						{
							this.state.currencyConversionOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL ?
							<div>
								<Text size="sm" as="span">
									{ userCountry === 'US' ?
										label.spread :
										label.fee
									}
								</Text>
							</div> :
							null
						}
					</div>
				</div>

				<div className="conversion-options-link ppvx_row">
					<div className="ppvx_col-12">
						<div>
							<a
								href="#"
								style={{ fontSize: 12 }}
								className="ppvx_link pp_cancel_btn"
								id="currencyConversionOptionsLink"
								onClick={this.handleCurrencyConversionClick}
								dangerouslySetInnerHTML={{__html : label.currencyConversionOptions}}>
			                </a>
			            </div>
					</div>
				</div>
			</React.Fragment>
		)
	};

	handleSecurityCodeChange = (securityCode) => {
		this.setState({
			securityCode: securityCode
		})
	}

	handleThreeDSStepUpAuthSuccess = () => {
		this.props.toggleSpinner(true);
		this.props.doFulfilment({
			securityCode: this.state.securityCode
		});
	}
	handleThreeDSStepUpAuthFailure = () => {
		// Unrecoverable error !!
		this.props.history.push('/donate/error/payment');
	}

	handleThreeDSFailure = () => {
		// Unrecoverable error !!
		this.props.history.push('/donate/error/threeDS');
	}

    render() {
		const inAmount = this.getLocalizedAmount(this.state.inAmount);
		const outAmount = this.getLocalizedAmount(this.state.outAmount);
		const fundsIn = `${this.state.inSymbol}${inAmount} ${this.state.inCurrency}`;
		const fundsOut = `${this.state.outSymbol}${outAmount} ${this.state.outCurrency}`;
		const exchangeRate = `${this.getLocalizedAmount('1.00')} ${this.state.inCurrency} = ${this.getLocalizedAmount(this.state.exchangeRate)} ${this.state.outCurrency}`;
		const { label = {} } = messages || {};
		let donateNowRecurring = _get(guestMessages, 'guestLabels.donatenowrec');
		donateNowRecurring = donateNowRecurring && donateNowRecurring.replace('{amount}', fundsOut);

		const formattedDonationAmount = `${this.state.symbol ? this.state.symbol : ''}${this.state.amount} ${this.state.currency}`;

		let giftaidFlag = AppStore.getGiftaidItFlagStatus();
		this.updateGiftAidComponent(this.state);

		let { csc: cscLabel, cscwarning } = guestMessages.guestLabels;
		cscwarning = cscwarning && cscwarning.replace('{csc}', cscLabel.toLowerCase());

		const { showCVVField } = this.state;

		return (
            <div className="donate_wrapper">
                <div id="crossBorderContainer" className="ppvx_container cross-border">
                    <CharityLogo logourl={this.state.logourl}/>

                    {showCVVField &&
					<div className="ppvx_row alert-container mb-8">
						<div className="ppvx_col-12">
                    		<Alert type="attention">{cscwarning}</Alert>
						</div>
					</div>
					}

                    <SubHeader
                        label={this.state.subHeaderLabel}
                        donationId={this.state.donationId}
                        orgName={this.state.orgName}
                        page="crossborder"
                    />
                    { /* <Amount
                        amount={outAmount}
                        symbol={this.state.outSymbol}
                        decimalPoint={this.state.decimalPoint}
                        code={this.state.outCurrency}/> */ }

                    {TemplateData.isGiftaiditEnabled && <DonateGiftAid
                                                            isAlreadyEnrolled={giftaidFlag}
                                                            showAddress={false}
                                                            addressData=''
                                                            isChecked={giftaidFlag}
                                                            handleGiftAidOption={this.handleGiftAidOption}
                                                            contentMsg={giftAidTextObj}/>
                    }


                    <div className="alignment-padding">
	                    <div className="ppvx_row">
	                    	<div className="ppvx_col-12">
								<Text size="md" medium>
									{label.donatingFrom}
								</Text>
	                    	</div>
	                    </div>
	                    <div className="ppvx_row">
	                    	<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
	                    		<div>
									<Text size="md">{this.state.paymentCard}</Text>
	                    		</div>
	                    		<div>
	                    			{
	                    			    this.state.currencyConversionOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL ?
	                    			    fundsIn :
	                    			    formattedDonationAmount
	                    			}
	                    		</div>
	                    	</div>
	                	</div>

	                	<div className="ppvx_row">
	                		<div className="ppvx_col-12">
	                			{ showCVVField && <CVVComponent
		                            onRef={ref => (this.childCVVInfo = ref)}
		                            handleSecurityCodeChange={ this.handleSecurityCodeChange }
		                            /> }
	                		</div>
	                	</div>
                    </div>




					{
                	    this.state.currencyConversionOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL ?
                	    <div className="ppvx_row">
                	    	<div className="ppvx_col-12">

                	    		<div className="conversion-block alignment-padding">
                	    			<div className="ppvx_row">
                	    				<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
				                    		<div>
												<Text as="span" size="md">{label.youllDonate}</Text>
				                    		</div>
				                    		<div>
				                    			<Text as="span" size="md">{fundsIn}</Text>
				                    		</div>
                	    				</div>
            	    				</div>

            	    				<div className="ppvx_row">
            	    					<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
				                    		<div>
												<Text as="span" size="sm">{label.convertsTo}</Text>
				                    		</div>
				                    		<div>
				                    			<Text as="span" size="sm">{fundsOut}</Text>
				                    		</div>
            	    					</div>
        	    					</div>
                	    		</div>

                	    	</div>
            	    	</div> :

                	    <div className="conversion-block alignment-padding">
    	    				<div className="ppvx_row">
    	    					<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
		                    		<div>
										<Text as="span" size="sm">{label.youllDonate}</Text>
		                    		</div>
		                    		<div>
		                    			<Text as="span" size="sm">{formattedDonationAmount}</Text>
		                    		</div>
    	    					</div>
	    					</div>
                	    </div>


                	}

					<div className="alignment-padding">
	                    { this.state.currencyConversionOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL &&  this.renderConversionRateInfo(exchangeRate, fundsOut) }
	                    { this.shouldShowCurrencyConversionOptions() && this.renderCurrencyConversionOptionsLink(label) }
	                    <div style={ { height: '40px' } } />

	                    <div className="ppvx_row">
	                    	<div
								className="ppvx_col-12 legal-text text-center"
								dangerouslySetInnerHTML={{ __html: setCountryAndLocale(label.policies) }}>
							</div>
	                    </div>

	                    <div style={ { height: '20px' } } />
					</div>


                    <div className="ppvx_row">
                    	<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
                		    <Button
                		    	className="btn-wide"
                		    	id="donate-button"
                		    	disabled={this.props.disabled}
                		    	onClick={this.handleDonateClick}
                		    >{ this.state.isRecurring ? donateNowRecurring : label.donatenow}
                		    </Button>
                    	</div>
                    </div>
                    <div style={ { height: '24px' } } />

                    {/*<div
                        className={css(STYLES.policyMsg)}
                        dangerouslySetInnerHTML={{__html: setCountryAndLocale(label.policies)}}/>

                    <div className={css(STYLES.donateBtnContainer)} >
                        <button
                            id="donate-button"
                            type="button"
                            style={STYLES.donateBtn}
                            className="ppvx_btn vx_btn-block"
                            onClick={this.handleDonateClick}>
                            { this.state.isRecurring ? donateNowRecurring : label.donatenow}
                        </button>
                    </div>*/}
                    <CancelAndReturn />
                    <CurrencyConversionModal
                    	isOpen={this.state.isCurrencyConversionModalOpen}
                        exchangeRate={exchangeRate}
                        handleOptionSelection={this.handleOptionSelection}
                        hideModal={this.hideCurrencyConversionModal}
                        selectedOption={this.state.currencyConversionOption}
                    />

                    <ThreeDSContainer
                        onThreeDSStepUpAuthNotRequired={this.handleThreeDSStepUpAuthSuccess}
                        onThreeDSStepUpAuthSuccess={this.handleThreeDSStepUpAuthSuccess}
                        onThreeDSStepUpAuthFailure={this.handleThreeDSFailure}
                        onThreeDSFailure={this.handleThreeDSFailure}
                        onRef={ref => (this.threeDSContainer = ref)}
                    />
                </div>
            </div>
        );
	}
}

export default withRouter(withDonate(CrossBorder));
